import React from "react";
import { Input } from "reactstrap";
import CurrencyFormat from "react-currency-format";

import { find } from "lodash";

const limitedValue = (max, min, value) => {
  if (value > max) return max;
  if (value < min) return min;
  return value;
};

const onBlur = (handleChangeVFMG, vfmgSelected, value) => {
  if (value > vfmgSelected?.RANGOVFMG?.Maximo) {
    handleChangeVFMG(vfmgSelected?.RANGOVFMG?.Maximo);
  } else if (value < vfmgSelected?.RANGOVFMG?.Minimo) {
    handleChangeVFMG(vfmgSelected?.RANGOVFMG?.Minimo);
  } else {
    handleChangeVFMG(limitedValue(vfmgSelected?.RANGOVFMG?.Maximo || 50, vfmgSelected?.RANGOVFMG?.Minimo || 0, parseInt(value)));
  }
}

const VFMGSlider = ({ handleChangeVFMG, loading, allFees, vfmg, fee }) => {

  const vfmgSelected = find(allFees, (e) => `${e.Plazo}` === `${fee}`);

  return (
    <div className="sm-vfmg-container">
      <div className="form-group">
        <label className="labe-simulation-home">VFMG</label>
        <CurrencyFormat
          id="VFMG"
          name="VFMG"
          className="form-control"
          onChange={(e) => handleChangeVFMG(parseInt(e.target.value))}
          onBlur={(e) => onBlur(handleChangeVFMG, vfmgSelected, e.target.value)}
          value={vfmg || 0}
          suffix={'%'}
          disabled={loading}
          placeholder="Seleccione el VFMG"
          required
          max={vfmgSelected?.RANGOVFMG?.Maximo || 50}
          min={vfmgSelected?.RANGOVFMG?.Minimo || 0}
        />
      </div>
      <section className="mt-4 mb-4 col-11 px-0 sf-range-container">
        <Input
          id="sf-range"
          className="sf-range"
          name="range"
          type="range"
          max={vfmgSelected?.RANGOVFMG?.Maximo || 50}
          min={vfmgSelected?.RANGOVFMG?.Minimo || 0}
          disabled={loading}
          value={vfmg || 0}
          onChange={(e) => handleChangeVFMG(e.target.value)}
        />
      </section>
    </div>
  )
};

export default VFMGSlider;